export default __webpack_public_path__ + "static/media/beauty_white.3a21dfde.svg";